import React, { Component } from 'react';
import Nav from './Nav';
import Header from './landing/Header';
import HowItWorks from './landing/HowItWorks';
import CookieConsent from "react-cookie-consent";
import Funfacts from './landing/Funfacts';
import Faq from './landing/Faq';
import Team from './landing/Team';
import Contact from './landing/Contact';
import Footer from './Footer';
import FadeIn from 'react-fade-in';
import DocumentTitle from 'react-document-title'
import { ToastContainer } from 'react-toastify';
import FeaturedCitizens from './landing/FeaturedCitizens';
import Patrons from './landing/Patrons';
class SynthCity extends Component {

    constructor(props) {
        super(props);
        this.state = {
            navData: {
                links: [
                    {
                        name: 'How It Works',
                        href: '#steps'
                    },
                    // {
                    //     name: 'Features',
                    //     href: '#features'
                    // },
                    // {
                    //     name: 'Benefits',
                    //     href: '#main-benefits'
                    // },
                    {
                        name: 'Faq',
                        href: '#faq'
                    },
                    // {
                    //     name: 'Pricing',
                    //     href: '#pricing'
                    // },
                    // {
                    //     name: 'Testimonials',
                    //     href: '#testimonials'
                    // },
                    // {
                    //     name: 'Team',
                    //     href: '#team'
                    // },
                    {
                        name: 'Contact',
                        href: '#contact'
                    },
                    {
                        name: 'Discord Community',
                        href: 'https://discordapp.com/invite/7JMza56'
                    },
                    {
                        name: 'Sign In',
                        href: 'https://app.synthcity.io/login'
                    },
                ],
                callToAction:
                {
                    name: 'Create Free Account',
                    href: 'https://app.synthcity.io'
                }
            }

        };
    }

    render() {
        return (
            <DocumentTitle title="The ultimate synthesizer preset collection! | synthCity">
                <FadeIn>
                    <div id="synty-city">
                        <ToastContainer />
                        <CookieConsent buttonText="Gotcha!">
                            synthCity uses cookies to enhance your experience. <span role="img" aria-label="cookie">🍪</span>*munch*
                        </CookieConsent>
                        {/* LOADER TEMPLATE */}
                        <div id="page-loader">
                            <div className="loader-icon fa fa-spin colored-border" />
                        </div>
                        <Nav navData={this.state.navData} />
                        <Header />
                        <HowItWorks />
                        {/* <Approach /> */}
                        {/* <Features /> */}
                        <Funfacts />
                        {/* <LatestVideos /> */}
                        {/* <MediaCoverage />
                        <Testimonials />
                        <Benefits /> */}
                        <Faq />
                        {/* <Pricing /> */}
                        <Team />
                        <FeaturedCitizens />
                        <Patrons />
                        {/* <CallToAction/> */}
                        <Contact />
                        <Footer />
                    </div>
                </FadeIn>
            </DocumentTitle>
        );
    }
}

export default SynthCity;


// WEBPACK FOOTER //
// ./src/components/synthcity/SynthCity.js